import { API_ENDPOINTS } from '../constants';

export const newsService = {
  async getNews(limit = 10, offset = 0) {
    const response = await fetch(`${API_ENDPOINTS.NEWS}?limit=${limit}&offset=${offset}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    // Transform API response to match expected format
    return {
      news: result.data || [],
      hasMore: result.hasMore || false,
      total: result.total || 0
    };
  },

  async getLatestNewsDate() {
    const response = await fetch(API_ENDPOINTS.NEWS_LATEST_DATE);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    // Transform API response to match expected format
    return {
      latestDate: result.lastUpdate || new Date().toISOString()
    };
  },
};

export default newsService;
